import {pageInfo, fetchDetail, synchSctDetail, driverGpsDetail, switchToWxGps} from './../api';
import {listShipper} from '../../../../api'
const TransportPlanFetchLog = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    rePushObj: null,
    fetchDetailTotal: 0,
    fetchDetailPageResp: null,
    synchSctDetailTotal: 0,
    synchSctDetailPageResp: null,
    driverGpsDetailTotal: 0,
    driverGpsDetailPageResp: null,
    shipperObj: null,
    switchToWxGpsObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    //查询可预约的订单
    FETCH_DETAIL_TABLE_DATA(state, data) {
      state.fetchDetailTotal = data.total;
      state.fetchDetailPageResp = data.obj;
    },
    SYNCH_SCT_DETAIL_TABLE_DATA(state, data) {
      state.synchSctDetailTotal = data.total;
      state.synchSctDetailPageResp = data.obj;
    },
    DRIVER_GPS_DETAIL_TABLE_DATA(state, data) {
      state.driverGpsDetailTotal = data.total;
      state.driverGpsDetailPageResp = data.obj;
    },
    LIST_SHIPPER(state, data) {
      state.shipperObj = data.obj || {};
    },
    SWITCH_TO_WX_GPS(state, data) {
      state.switchToWxGpsObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //查询事件
    async fetchDetailPageInfo({commit}, obj) {
      let resp = await fetchDetail(obj);
      commit('FETCH_DETAIL_TABLE_DATA', resp);
    },
    async synchSctDetailPageInfo({commit}, obj) {
      let resp = await synchSctDetail(obj);
      commit('SYNCH_SCT_DETAIL_TABLE_DATA', resp);
    },
    async driverGpsDetailPageInfo({commit}, obj) {
      let resp = await driverGpsDetail(obj);
      commit('DRIVER_GPS_DETAIL_TABLE_DATA', resp);
    },
    /*主数据-货主*/
    async listShipper({ commit }, obj) {
      let resp = await listShipper(obj);
      commit('LIST_SHIPPER', resp);
    },
    //切换小程序轨迹
    async switchToWxGps({ commit }, obj) {
      let resp = await switchToWxGps(obj);
      commit('SWITCH_TO_WX_GPS', resp);
    },
  }
}
export default TransportPlanFetchLog



// WEBPACK FOOTER //
// ./src/page/log/TransportPlanFetchLog/store/TransportPlanFetchLog.store.js